var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2voz172kba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 88",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 89",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3",
    transform: "translate(12 12)",
    style: {
      clipPath: "url(#2voz172kba)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 323"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 4",
    transform: "rotate(45 -2.127 5.35)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 5",
    transform: "rotate(135 8.015 5.119)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.2612ceb2f3add1ba1f553fdb823544a4.svg";
export { ForwardRef as ReactComponent };